// extracted by mini-css-extract-plugin
export default {"page":"UO","top_block":"VO","heading":"WO","inner_text":"XO","starter_text":"YO","starter_cta":"ZO","summary_block":"aP","cartsummary_wrap":"bP","price":"cP","pricing_wrap":"eP","summary_block_mob":"fP","summary":"gP","pricing_heading":"hP","products_summary":"iP","summary_line":"jP","summary_price":"kP","summary_title":"lP"};
    if(module.hot) {
      // 1711717534227
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  